import { render, staticRenderFns } from "./app-refresh.vue?vue&type=template&id=fb05560a&scoped=true&"
import script from "./app-refresh.vue?vue&type=script&lang=js&"
export * from "./app-refresh.vue?vue&type=script&lang=js&"
import style0 from "./app-refresh.vue?vue&type=style&index=0&id=fb05560a&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb05560a",
  null
  
)

export default component.exports